import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Swal from 'sweetalert2';
import { FileService } from '../../service/file.service';

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss']
})
export class UploadImageComponent implements OnInit {
  dragOver = false;
  error: boolean | null | undefined = false;
  @Input() boxWidth: string = '2rem';
  @Input() boxHeight: string = '2rem';
  @Input() fileType: string[] = ['image/png', 'image/jpeg'];
  @Output() onImageSelected = new EventEmitter<string>();
  @Output() onImageSelectedBlob = new EventEmitter<Blob>();
  @Input() image?: string;
  @Input() title = 'لطفا لوگو ارز را انتخاب کنید';
  @Input() description = 'حداکثر حجم فایل ۲۰ کیلوبایت می‌باشد.'

  now = (new Date()).getTime().toString();

  Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  constructor(private fileService:FileService) {
  }


  getFile(evt: any): void {
    this.processImage(evt);
  }

  processImage($event: any) {
    $event.preventDefault();
    const file = $event.dataTransfer ? $event.dataTransfer.files[0] : $event.target.files[0];
    if (
      file &&
      (this.fileType.includes(file.type))
    ) {
      const reader = new FileReader();
      reader.onload = (fileReader: any) => {
        this.image = `data:${file.type};base64,` + btoa(fileReader.target.result);
        this.onImageSelected.emit(this.image);
        this.onImageSelectedBlob.emit(this.fileService.dataURIToBlob(this.image))
      };
      reader.readAsBinaryString(file);
    } else {
      this.Toast.fire({
        icon: 'error',
        text: `فرمت فایل انتخابی باید یکی از فرمت‌های ${this.fileType.join(' ')} باشد.`
      });
    }
  }

  onDrop($event: any): void {
    this.processImage($event);
    this.dragOver = false;
  }

  drag($event: any): void {
    $event.preventDefault();
    $event.dataTransfer.effectAllowed = 'none';
    $event.dataTransfer.dropEffect = 'none';
  }

  ngOnInit(): void {
  }

}
